export default "__VITE_ASSET__BbZueUmR__"